// actions/userActions.js
export const setUser = (user) => {
    return {
      type: 'SET_USER',
      payload: user,
    };
  };
  